










import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
@Component({})
export default class PreviewPhoto extends VueBase {
	urls!: any
	// file: FlieUrl = new FlieUrl()
	fileList: Array<FlieUrl> = []
	onClickLeft() {
		window.history.go(-1)
	}

	created() {
		this.urls = this.$route.query.urls
		this.urls.forEach((t: any) => {
			let file = { url: '' }
			file.url = t
			this.fileList.push(file)
		})
	}
}
class FlieUrl {
	url: string = ''
}
